module.exports = __webpack_public_path__ + "img/Excel.5b7b17af.svg";